// extracted by mini-css-extract-plugin
export default {"titleContainer":"CreationFormsTabs_titleContainer__PVxpf","title":"CreationFormsTabs_title__bJJDC"};